// waterMark.js
export function setWatermark(text = "YOLEE © DO NOT COPY") {
  removeWatermark();

  const canvas = document.createElement("canvas");
  canvas.width = 300;
  canvas.height = 200;

  const ctx = canvas.getContext("2d");
  ctx.rotate((-20 * Math.PI) / 180);
  ctx.font = "17px Arial";
  ctx.fillStyle = "rgba(0, 0, 0, 0.17)";
  ctx.textAlign = "left";
  ctx.textBaseline = "middle";
  ctx.fillText(text, 30, canvas.height / 2);

  const watermark = document.createElement("div");
  watermark.id = "global-watermark";
  watermark.style.pointerEvents = "none";
  watermark.style.position = "fixed";
  watermark.style.top = "0";
  watermark.style.left = "0";
  watermark.style.zIndex = "9999";
  watermark.style.width = "100%";
  watermark.style.height = "100%";
  watermark.style.background = `url(${canvas.toDataURL("image/png")}) repeat`;
  document.body.appendChild(watermark);
}

export function removeWatermark() {
  const wm = document.getElementById("global-watermark");
  if (wm) wm.remove();
}
